<template>
  <footer>
    <div>
      <img :src="whitelabel?.logo" alt="" />
    </div>
  </footer>
</template>

<script>
export default {
  name: "ConteudoPrincipal",
};
</script>

<style scoped>
footer {
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 1rem;
}

img {
  width: 100px;
}

a {
  color: var(--color-default);
}
</style>
